import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/icons/right_arrow.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/advertising.png");
;
import(/* webpackMode: "eager" */ "/app/public/industry/advertising/adchannel.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/advertising/market_research.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/consumer_goods.png");
;
import(/* webpackMode: "eager" */ "/app/public/industry/consumer/consumer-Insight.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/consumer/market-analysis.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/consumer/patient-insights.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/entertainment.png");
;
import(/* webpackMode: "eager" */ "/app/public/industry/entertainment/consumer-Insight.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/entertainment/insights-tracker.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/entertainment/product_testing.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/financial_services.png");
;
import(/* webpackMode: "eager" */ "/app/public/industry/financialService/brand_health.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/financialService/competitive_benchmarking.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/financialService/digital_transformation.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/financialService/market_trend.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/financialService/process_improvment.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/financialService/product_development.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/financialService/security_threats.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/food_beverege.png");
;
import(/* webpackMode: "eager" */ "/app/public/industry/food/brand_position.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/food/brand-performace.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/food/concept_testing.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/food/consumer_research.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/food/market_analysis.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/food/market_segment.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/food/product-testing.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/healthcare.png");
;
import(/* webpackMode: "eager" */ "/app/public/industry/healthCare/brand-strategy.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/sports.png");
;
import(/* webpackMode: "eager" */ "/app/public/industry/sports/ad.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/sports/event-research.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/sports/sponsorship.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/technology.png");
;
import(/* webpackMode: "eager" */ "/app/public/industry/technology/brand_positioning.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/technology/customer_insights.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/technology/IT_stratergy.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/technology/technology_adoption.svg");
;
import(/* webpackMode: "eager" */ "/app/public/slm/icon/home.svg");
